import { useState } from "react";
import { useScroll } from "shared/hooks/useScroll";
import tw from "twin.macro";

export const fortuneTellerTab = {
  profile: {
    label: "プロフィール",
    to: "profile",
  },
  menu: {
    label: "占いメニュー",
    to: "menu",
  },
  review: {
    label: "感想・レビュー",
    to: "review",
  },
} as const;

interface Props {
  scrollRoot?: Element;
  tabs?: (keyof typeof fortuneTellerTab)[];
}

export const FortuneTellerTab = ({
  scrollRoot,
  tabs: tabKeys = ["profile", "menu", "review"],
}: Props) => {
  const [activeTab, setActiveTab] = useState<keyof typeof fortuneTellerTab>(
    fortuneTellerTab.profile.to
  );
  const { scrollTo } = useScroll();

  const tabs = Object.values(tabKeys.map((key) => fortuneTellerTab[key]));

  const handleClickTab = (to: keyof typeof fortuneTellerTab) => {
    setActiveTab(to);
    scrollTo(to, { offset: -25, root: scrollRoot });
  };

  return (
    <ul tw="flex border-b border-solid border-gray mt-8">
      {tabs.map(({ label, to }) => (
        <li
          key={to}
          tw="text-center font-semibold text-[14px] border-b-2 border-solid py-3"
          css={[
            { width: `calc(100% / ${tabs.length})` },
            to === activeTab
              ? tw`text-theme border-theme`
              : tw`text-secondary border-none`,
          ]}
        >
          <button tw="cursor-pointer" onClick={() => handleClickTab(to)}>
            {label}
          </button>
        </li>
      ))}
    </ul>
  );
};
